import {ConfirmationDialog} from '@ui/molecules/confirmation-dialog';

interface FeedbackDismissModalProps {
  request: {id: string; subjectName: string} | null;
  action?: 'dismiss' | 'delete' | 'delete-praise';
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const FeedbackDismissModal = ({
  request,
  action = 'dismiss',
  isLoading = false,
  onClose,
  onConfirm,
}: FeedbackDismissModalProps) => {
  if (!request) return null;

  const deleting = action === 'delete';
  const deletingPraise = action === 'delete-praise';

  const handleClose = () => {
    if (!isLoading) onClose();
  };

  const title = deletingPraise
    ? 'Delete praise?'
    : deleting
    ? 'Delete feedback request?'
    : 'Dismiss feedback request?';
  const confirmLabel = deletingPraise
    ? 'Delete praise'
    : deleting
    ? 'Delete request'
    : 'Dismiss request';

  return (
    <ConfirmationDialog
      open
      title={title}
      confirmLabel={confirmLabel}
      isLoading={isLoading}
      onCancel={handleClose}
      onConfirm={onConfirm}>
      {deletingPraise ? (
        <>
          This will remove <strong>{request.subjectName}</strong> from the
          Praise wall. People will no longer be able to see it.
        </>
      ) : deleting ? (
        <>
          This will permanently delete <strong>{request.subjectName}</strong>.
          This action can’t be undone.
        </>
      ) : (
        <>
          This will permanently remove <strong>{request.subjectName}</strong>.
          You won’t be able to respond to it later.
        </>
      )}
    </ConfirmationDialog>
  );
};
